import './index.css';
import '../node_modules/mmenu-js/';
import '../scripts/dropdowns.js';
import '../scripts/mmenu.js';


//Agent dashboard grab video thumbnail

var elem = jQuery('.acf-file-uploader.has-value');

elem.each(function() {
    var src = jQuery(this).find("a[data-name=filename]").attr('href');
	jQuery(this).append('<video src="'+src+'"></video>');
});

//create listener event for class change
jQuery(function() {
(function(jQuery) {
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

    jQuery.fn.attrchange = function(callback) {
        if (MutationObserver) {
            var options = {
                subtree: false,
                attributes: true
            };

            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(e) {
                    callback.call(e.target, e.attributeName);
                });
            });

            return this.each(function() {
                observer.observe(this, options);
            });

        }
    }
})(jQuery);

//Now you need to append event listener
jQuery('.acf-file-uploader').attrchange(function(attrName) {

    if(attrName=='class'){
    	if (jQuery(this).hasClass('has-value')) {
             var src = jQuery(this).find("a[data-name=filename]").attr('href');
             jQuery(this).append('<video src="'+src+'"></video>');
        } else {
        	jQuery(this).find('video').remove();
        }
    }

});
});